import * as z from 'zod'

import { blockSchema } from '../..'
import {
  blockPayloadSchema,
  commitPayloadSchema,
  eventBlockPayloadSchema,
  layoutBlockPayloadSchema,
  listBlockPayloadSchema,
} from './index.ts'
import {
  isDocumentLikeBlock,
  isWorkflowTriggerBlockChangeCompatible,
} from '../../../type-casts'

export const layoutBlockPayloadSchema__BC = layoutBlockPayloadSchema.extend({
  data: layoutBlockPayloadSchema.shape.data.extend({
    updatedBlock: z
      .lazy(() =>
        blockSchema.refine(
          (block) => {
            return (
              isWorkflowTriggerBlockChangeCompatible(block) ||
              isDocumentLikeBlock(block)
            )
          },
          {
            message:
              'Block is not compatible with workflow trigger block change',
          }
        )
      )
      .optional()
      .describe(
        'Deprecated, leaving here for backwards compatibility. Use updatedBlockId instead.'
      ),
  }),
})

// For the run entity, we had a different payload schema than the onw we used for `workflowBlock -> activeRuns` leaving here for backwards compat
export const workflowActiveRunPayloadSchema__BC = z.union([
  commitPayloadSchema,
  listBlockPayloadSchema,
  eventBlockPayloadSchema,
  layoutBlockPayloadSchema__BC,
  blockPayloadSchema,
])
